import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeSlug from "rehype-slug";
import AppLayout from "@/components/app-layout";
import { HOST_FAQ_CONTENT } from "@/data/host-faq-content";
import { usePageTitle } from "@/hooks/use-page-title";
import { ShareFaqButton } from "@/components/share-faq-button";
import { ExplainerVideoButton } from "@/components/explainer-video-button";
import { GuideButton } from "@/components/guide-button";
import { GuideNudgeBanner } from "@/components/guide-nudge-banner";

export default function AppFaqPage() {
  usePageTitle("FAQ");
  return (
    <AppLayout>
      <div className="max-w-4xl mx-auto px-6 py-8" data-testid="page-faq">
        <div className="flex items-center justify-end gap-2 mb-4">
          <div data-tour="faq-share">
            <ShareFaqButton path="/faq/hosts" testId="button-share-faq-app-host" />
          </div>
          <ExplainerVideoButton pageKey="faq" />
          <GuideButton pageKey="faq" />
        </div>

        <GuideNudgeBanner pageKey="faq" />

        <article
          className="prose prose-sm sm:prose-base dark:prose-invert max-w-none prose-headings:scroll-mt-20 prose-h1:text-3xl prose-h2:text-xl prose-h2:mt-10 prose-h3:text-base prose-h3:mt-6 prose-a:text-blue-600 dark:prose-a:text-blue-400 prose-blockquote:text-gray-600 dark:prose-blockquote:text-muted-foreground"
          data-testid="text-faq-content"
          data-tour="faq-heading"
        >
          <ReactMarkdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeSlug]}>
            {HOST_FAQ_CONTENT}
          </ReactMarkdown>
        </article>
      </div>
    </AppLayout>
  );
}
